import { render, staticRenderFns } from "./CustomList.vue?vue&type=template&id=061cb422&scoped=true&"
import script from "./CustomList.vue?vue&type=script&lang=ts&"
export * from "./CustomList.vue?vue&type=script&lang=ts&"
import style0 from "./CustomList.vue?vue&type=style&index=0&id=061cb422&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061cb422",
  null
  
)

export default component.exports